import { useEffect, useRef } from 'react';
import { getTargetElement } from '../utils/dom';
import useUnmount from './useUnmunt';
import { depsAreSame } from '../utils';
export default function useEffectWithTarget(effect, deps, target) {
  var hasInitRef = useRef(false);
  var lastElementRef = useRef([]);
  var lastDepsRef = useRef([]);
  var unLoadRef = useRef();
  useEffect(function () {
    var _a;

    var targets = Array.isArray(target) ? target : [target];
    var els = targets.map(function (item) {
      return getTargetElement(item);
    });

    if (!hasInitRef.current) {
      hasInitRef.current = true;
      lastElementRef.current = els;
      lastDepsRef.current = deps;
      unLoadRef.current = effect();
      return;
    }

    if (els.length !== lastElementRef.current.length || !depsAreSame(els, lastElementRef.current) || !depsAreSame(deps, lastDepsRef.current)) {
      (_a = unLoadRef.current) === null || _a === void 0 ? void 0 : _a.call(unLoadRef);
      lastElementRef.current = els;
      lastDepsRef.current = deps;
      unLoadRef.current = effect();
    }
  });
  useUnmount(function () {
    var _a;

    (_a = unLoadRef.current) === null || _a === void 0 ? void 0 : _a.call(unLoadRef);
    hasInitRef.current = false;
  });
}